import React, { useState } from "react";
import { validateForm } from "../utils/validation/validate-contact-us"; // Import validation logic
// import mailIcon from "../assets/icons/mail.svg";
// import mapPinIcon from "../assets/icons/map-pin.svg";
// import phoneIcon from "../assets/icons/phone.svg";
import { Col, Container, Row } from "react-bootstrap";
import { submitContactForm } from "../services/contact-service";
import "react-phone-number-input/style.css";
import { handleErrors } from "../utils/errorHandler";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import contactBanner from "../assets/images/contact-us.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    country: "0",
    phone: "",
    subject: "",
    description: "",
  });

  const [errors, setErrors] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitting(true);
      try {
        const contactResponse = await submitContactForm(formData);

        if (contactResponse.status === 200) {
          setSubmissionStatus(
            "Thank you for contacting us! We’ll be in touch soon."
          );
          setFormData({
            name: "",
            email: "",
            country: "0",
            phone: "",
            subject: "",
            description: "",
          });
        } else {
          throw new Error("Failed to submit the form.");
        }
      } catch (error) {
        let errorMessage = handleErrors(error);
        if (error.response && error.response.status === 500) {
          errorMessage = error.response.data.message;
        }
        toast.error(errorMessage);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <>
      <section className="inner-full-banner">
        <div className="banner-img-wrap">
          <img src={contactBanner} alt="" />
        </div>
      </section>
      <section className="pb-0 mt-5">
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <div className="rent-prop-title text-center">
                <h1>Contact Us</h1>
                <p>
                  We’re here to provide top-notch facility management and
                  maintenance services tailored to your needs. Whether you have
                  a question, need a customized service plan, or want to explore
                  partnership opportunities, our team is ready to assist you.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="contact-info-sec p-5">
        <Container>
          <Row>
            <Col lg={6}>
              <div className="map-info">
                <h3>Find Us On</h3>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2967.8862835683544!2d-73.98256668525309!3d41.93829486962529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e81a20b7359e41%3A0x4f3e23324ec66f82!2sB%C3%B6rger%20Medien!5e0!3m2!1sen!2sin!4v1639131337261!5m2!1sen!2sin"
                  width="100%"
                  height="400"
                  allowFullScreen=""
                  loading="lazy"
                  title="Office Location"
                ></iframe>
              </div>
            </Col>
            <Col lg={6}>
              <div className="contact-info">
                <div className="meta-details">
                  <h3>We are located at</h3>
                  <h3>Omshakthi Monitoring Service Private Limited</h3>
                  <Link to={"#"}>
                    Bhive L-148, 5th Main Road, Sector 6, HSR Layout, Bangalore,
                    Karnataka, India - 560102{" "}
                  </Link>
                </div>
                <div className="meta-details">
                  <h3>Email Us</h3>
                  <Link to={"mailto:omsprivateltd@gmail.com"}>
                    omsprivateltd@gmail.com
                  </Link>
                </div>
                <div className="meta-details">
                  <h3>Call us</h3>
                  <Link to={"tel:+911234567890"}>+91 9108644850</Link>
                </div>
                <div className="meta-details">
                  <h3>Social Media</h3>
                  <div className="social-links">
                    <Link to={"#"}>
                      <FontAwesomeIcon icon={faFacebookF} />
                    </Link>
                    <Link to={"#"}>
                      <FontAwesomeIcon icon={faInstagram} />
                    </Link>
                    <Link to={"#"}>
                      <FontAwesomeIcon icon={faLinkedinIn} />
                    </Link>
                    <Link to={"#"}>
                      <FontAwesomeIcon icon={faXTwitter} />
                    </Link>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={12} className="">
              {submissionStatus ? (
                <div
                  className={`alert ${
                    submissionStatus.includes("Thank you")
                      ? "alert-success"
                      : "alert-danger"
                  }`}
                  role="alert"
                >
                  {submissionStatus}
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-12">
                      <h3>Get in Touch</h3>
                      <p>
                        Fill out the form below, and our team will reach out to
                        you shortly!
                      </p>
                    </div>
                    <div className="col-lg-12 col-12">
                      <div className="form-group">
                        <label>Your Name</label>
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <div className="text-danger">{errors.name}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6 col-12">
                      <div className="form-group">
                        <label>Phone Number</label>
                        <input
                          type="phone"
                          maxLength="15"
                          name="phone"
                          className="form-control"
                          placeholder="Enter phone number"
                          value={formData.phone}
                          onChange={handleChange}
                        />

                        {errors.phone && (
                          <div className="text-danger">{errors.phone}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6 col-12">
                      <div className="form-group">
                        <label>Email Address</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Enter Email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="text-danger">{errors.email}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6 col-12">
                      <div className="form-group">
                        <label>Country</label>
                        <select
                          name="country"
                          className="form-control"
                          value={formData.country}
                          onChange={handleChange}
                        >
                          <option value="0">Select </option>
                          <option value="India">India</option>
                          <option value="United States">United States</option>
                          <option value="Australia">Australia</option>
                          <option value="Oman">Oman</option>
                          <option value="Qatar">Qatar</option>
                        </select>
                        {errors.country && (
                          <div className="text-danger">{errors.country}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6 col-12">
                      <div className="form-group">
                        <label>Subject</label>
                        <input
                          type="text"
                          name="subject"
                          className="form-control"
                          placeholder="Enter Subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                        {errors.subject && (
                          <div className="text-danger">{errors.subject}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Description</label>
                        <textarea
                          name="description"
                          className="form-control"
                          rows="5"
                          placeholder="Comments"
                          value={formData.description}
                          onChange={handleChange}
                        ></textarea>
                        {errors.description && (
                          <div className="text-danger">
                            {errors.description}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="btn orange-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit Enquiry"}
                  </button>
                </form>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ContactUs;
